
import { Component, Vue } from 'vue-property-decorator'
import { CONFIGAPI } from '@/api/config'
import { config, openSingleChat } from 'yach.open.jssdk'

@Component({
  name: 'YachChat'
})
export default class YachChat extends Vue {
  private isOpened = false

  private openYachChat(yachId: string) {
    const href = decodeURIComponent(window.location.href)
    CONFIGAPI.getJsConfig({ url: href }).then(res => {
      if (res.stat === 1) {
        const {
          corp_id,
          time_stamp,
          nonce_str,
          signature,
          agentId,
          ttl
        } = res.data
        // if (ttl > 0) {
        //   this.doOpenChat(yachId)
        //   return
        // }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const _this = this
        config({
          agentId: agentId,
          corpId: corp_id,
          timeStamp: time_stamp,
          nonceStr: nonce_str,
          signature: signature,
          jsApiList: ['biz.chat.openSingleChat'],
          onSuccess: function (result: any) {
            _this.doOpenChat(yachId)
            _this.isOpened = true
          },
          onFail: function (err: any) {
            console.log('call error', err)
          }
        })
        if (!_this.isOpened) {
          _this.doOpenChat(yachId)
        }
      }
    })
  }

  private doOpenChat(yachId: string) {
    // @ts-ignore
    openSingleChat({
      userId: yachId
    })
  }

  public onOpenSingleChat(ticket: any) {
    const name = ticket.creator.name
    const workcode = ticket.creator.workcode
    this.$confirm(`是否要打开与<span style="color: orange; font-weight: bold">${name}(${workcode})</span>老师知音楼对话框？`,
      '提示',
      {
        type: 'warning',
        dangerouslyUseHTMLString: true,
        confirmButtonText: '是',
        cancelButtonText: '否'
      }).then(_ => {
      console.log('打开成功')
      const yachId = ticket.creator.yachid
      this.openYachChat(yachId)
    })
  }
}
